import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import DepositoService from "service/suprimentos/DepositoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const depositoService = new DepositoService();

export default function DepositoListagem() {

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={depositoService} urlService="/deposito" tituloPagina={'Depósito'} defaultFilters={defaultFilters} showClearFilterButton nome="deposito" >
            <Column field="codigo" header="Código" style={{ width: '10em' }} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" 
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate}/>
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ativo" header="Ativo" style={{ width: '5em', textAlign: "center" }} body={(rowData)=><Checkbox checked={rowData.ativo} />} />
        </BaseListagem>
    )
}
